/* Guía de pez: índice automático desde los H2 y sección activa. Ver sections/guia-pez.liquid. */
(function () {
  'use strict';

  /* ---- Indice: se arma solo con los H2 de .secciones (sirve igual en otras guias) ---- */
  var secciones = document.getElementById('secciones');
  var lista = document.getElementById('indice-lista');
  var caja = document.querySelector('.indice__caja');
  if (!secciones || !lista || !caja) return;
  var resumen = caja.querySelector('summary');
  var titulos = secciones.querySelectorAll('h2:not([data-sin-indice])');
  var enlaces = [];

  function slug(t) {
    return t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  titulos.forEach(function (h2) {
    var sec = h2.closest('section');
    var id = (sec && sec.id) || slug(h2.textContent);
    if (sec && !sec.id) sec.id = id;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h2.textContent;
    li.appendChild(a);
    lista.appendChild(li);
    enlaces.push({ a: a, sec: sec || h2 });
  });

  /* Abierto en pantallas >= 750 px; fijo (no se cierra) desde 1200 px */
  var mq750 = window.matchMedia('(min-width: 750px)');
  var mq1200 = window.matchMedia('(min-width: 1200px)');
  function sincronizar() {
    if (mq750.matches) caja.open = true;
    resumen.tabIndex = mq1200.matches ? -1 : 0;
  }
  sincronizar();
  mq750.addEventListener('change', function () { caja.open = mq750.matches; sincronizar(); });
  mq1200.addEventListener('change', sincronizar);
  resumen.addEventListener('click', function (e) { if (mq1200.matches) e.preventDefault(); });
  lista.addEventListener('click', function () {
    if (!mq750.matches) caja.open = false;
  });

  /* Seccion activa (feedback de donde esta el lector) */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        enlaces.forEach(function (x) {
          if (x.sec === en.target) x.a.setAttribute('aria-current', 'true');
          else x.a.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-20% 0px -65% 0px' });
    enlaces.forEach(function (x) { io.observe(x.sec); });
  }

  /* ---- Fotos que aun no existen: fondo de color, sin icono roto ---- */
  function marcarFalta(img) {
    var respaldo = img.getAttribute('data-respaldo');
    if (respaldo && img.src.indexOf(respaldo) === -1) { img.removeAttribute('data-respaldo'); img.src = respaldo; return; }
    var cont = img.closest('.foto');
    if (cont) cont.classList.add('foto--falta');
  }
  document.querySelectorAll('.foto img').forEach(function (img) {
    img.addEventListener('error', function () { marcarFalta(img); });
    if (img.complete && img.naturalWidth === 0 && img.currentSrc) marcarFalta(img);
  });
})();

/* Tarjetas de peces y comida: al abrir la página se revisa precio y stock; lo agotado se saca. */
(function () {
  'use strict';
  document.querySelectorAll('[data-minis]').forEach(function (bloque) {
    var items = bloque.querySelectorAll('li[data-handle]');
    var pendientes = items.length;
    function listo() {
      pendientes -= 1;
      if (pendientes <= 0 && !bloque.querySelector('li[data-handle]')) bloque.remove();
    }
    items.forEach(function (li) {
      fetch('/products/' + li.getAttribute('data-handle') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          if (!p.available) { li.remove(); return; }
          var precio = li.querySelector('.mini__precio');
          if (precio) precio.textContent = '$' + Math.round(p.price / 100).toLocaleString('es-CL');
        })
        .catch(function () {})
        .then(listo);
    });
  });
})();
